/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    SimpleShowLayout,
    ReferenceInput,
    ReferenceField,
    NumberField,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { AutocompleteInput, BooleanInput, NumberInput, TextInput } from '../lib/wrappers/Inputs';

export const FacultyGroupLabels = {
    pageTitle: 'Schools',
    singleLabel: 'School',
    Title: 'Code',
    faculty_id: 'Faculty',
    type_id: 'Type',
};

export const FacultyGroupList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} filters={<BaseFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="description" />
                    <NumberField source="type_id" />
                    <BooleanField source="current" />
                    <TextField label={FacultyGroupLabels.Code} source="Title" />
                    <ReferenceField
                        label={FacultyGroupLabels.faculty_id}
                        reference="Faculty"
                        source="faculty_id"
                        allowEmpty
                    >
                        <TextField source="Title" />
                    </ReferenceField>
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const FacultyGroupEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm  toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput label="Code" source="Title" />
                    <TextInput source="description" />
                    <BooleanInput source="current" />
                    <NumberInput
                        label={FacultyGroupLabels.type_id}
                        source="type_id"
                    />
                    <ReferenceInput
                        label={FacultyGroupLabels.faculty_id}
                        reference="Faculty"
                        source="faculty_id"
                    >
                        <AutocompleteInput optionText="description" />
                    </ReferenceInput>
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const FacultyGroupCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label="Code" source="Title" />
            <TextInput source="description" />
            <BooleanInput source="current" defaultValue={false} />
            <NumberInput label={FacultyGroupLabels.type_id} source="type_id" />
            <ReferenceInput
                label={FacultyGroupLabels.faculty_id}
                reference="Faculty"
                source="faculty_id"
            >
                <AutocompleteInput optionText="description" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export const FacultyGroupShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Code" source="Title" />
            <TextField source="description" />
            <BooleanField source="current" />
            <TextField label={FacultyGroupLabels.type_id} source="type_id" />
            <ReferenceField
                label="Faculty"
                reference="Faculty"
                source="faculty_id"
                allowEmpty
            >
                <TextField source="description" />
            </ReferenceField>
            <TextField source="created_at" />
            <TextField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
